var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.9999,
    cy: 19.9999,
    r: 19.4999,
    fill: "white",
    stroke: "#D0D5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9173 20.3599L8.6207 12.5229C8.23992 12.879 8 13.3836 8 13.9455V26.166C8 26.7558 8.26314 27.2836 8.67797 27.6412L18.5597 20.7794C18.3337 20.6679 18.117 20.5286 17.9173 20.3599Z",
    fill: "#FFBC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0001 26.1676V13.9455C32.0001 13.3836 31.7602 12.8774 31.3794 12.5229L22.0844 20.3599C21.8831 20.5286 21.6664 20.6679 21.4404 20.7794L31.3221 27.6412C31.737 27.2852 32.0001 26.7573 32.0001 26.1676Z",
    fill: "#FFBC00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4385 20.7812L19.999 19.7812L18.5595 20.7812L8.67773 27.6414C9.01827 27.934 9.46097 28.112 9.94545 28.112H30.0525C30.537 28.112 30.9797 27.934 31.3202 27.6414L21.4385 20.7812Z",
    fill: "#FC9C29"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0841 20.3601L31.3792 12.5232C31.0309 12.1997 30.5666 12 30.0542 12H9.94715C9.43325 12 8.96888 12.1997 8.62061 12.5232L17.9157 20.3601C19.1199 21.3756 20.8799 21.3756 22.0841 20.3601Z",
    fill: "#FFD833"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.c4fd5929aba8de145964fcf8a56c8ba2.svg";
export { ForwardRef as ReactComponent };